import api from "../../api";
import {promptData, successPromptData} from "../../util/MessageTools";
import {dateStr2Timestamp} from "../../util/TimeTransition";
import {userTypeEnumToString, checkEnumToString} from "../../util/EnumTransition";
import router from "../../router";
import th from "element-ui/src/locale/lang/th";

export default {
  name: "contribute_manage",
  data() {
    return {
      //短信群发窗口
      massDlgVisible:false,
      //群发短信窗口内容
      massValue:'',
      numberOptions: [{
        value: 1,
        label: "第一阶段"
      }, 
      // {
      //   value: 2,
      //   label: "第二阶段"
      // }, 
      {
        value: 3,
        label: "第三阶段"
      }],
      enterForOptions: [{
        value: 1,
        label: "开启"
      }, {
        value: 0,
        label: "关闭"
      }],
      oneContributeOption: [{
        value: 1,
        label: "开启"
      }, {
        value: 0,
        label: "关闭"
      }],
      twoContributeOption: [{
        value: 1,
        label: "开启"
      }, {
        value: 0,
        label: "关闭"
      }],
      threeContributeOption: [{
        value: 1,
        label: "开启"
      }, {
        value: 0,
        label: "关闭"
      }],

      contribute: {
        curRound: "",
        certificate: 1,
        round1Submit: 1,
        round2Submit: 1,
        round3Submit: 1,
      },
    }
  },
  methods: {
    sendSms(){
      let that = this
      api.enterFor.sendBatchSms().then(function(res){
        that.massDlgVisible = false
        successPromptData("群发短信成功！", that)
      }).catch(error =>{
        that.massDlgVisible = false
      })
    },
    massTexting(){
      let that = this
      api.enterFor.sendBatchSmsBefore().then(function(res){
        that.massValue = res.data.result
        that.massDlgVisible = true
      })

    },
    /**
     * 修改比赛进度
     */
    saveContribute() {
      let vue = this
      let obj = {}
      obj.curRound = vue.contribute.curRound
      obj.certificate = vue.contribute.certificate
      obj.round1Submit = vue.contribute.round1Submit
      obj.round2Submit = vue.contribute.round2Submit
      obj.round3Submit = vue.contribute.round3Submit
      api.gameRule.updateGameRule(obj).then(function (response) {
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          //更新vuex
          router.app.$options.store.state.curRound = vue.contribute.curRound
          router.app.$options.store.state.certificate = vue.contribute.certificate
          router.app.$options.store.state.round1Submit = vue.contribute.round1Submit
          router.app.$options.store.state.round2Submit = vue.contribute.round2Submit
          router.app.$options.store.state.round3Submit = vue.contribute.round3Submit
          successPromptData("修改比赛进度成功！", vue)
        }
      })
    },

    /**
     * 修改第一阶段的开启状态时,同步报名字段的状态
     */
    changeRound1(value){
      this.contribute.certificate = value
    }
  },

  created() {
    let vue = this
    //查询轮数
    api.gameRule.getGameRule().then(function (response) {
      if (response == null) {
        return null
      }
      if (response.data.code === "0") {
        let result = response.data.result
        vue.contribute.curRound = result.curRound
        vue.contribute.certificate = result.certificate
        vue.contribute.round1Submit = result.round1Submit
        vue.contribute.round2Submit = result.round2Submit
        vue.contribute.round3Submit = result.round3Submit
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/Admin/ContributeManage.js